import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import './RouteMap.css'; // Import your custom CSS file 
import busyTruck from '../assets/img/busyTruck.png'
const RouteMap = (props) => {
  const [activeMarker, setActiveMarker] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState({});
  const [mapLoaded, setMapLoaded] = useState(false);
  const mapRef = useRef(null);

  const containerStyle = {
    width: '100%',
    height: '600px',
  };

  const center = {
    lat: 33.429078,
    lng: -111.943817,
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCPhSP57_v3UIrDN-9EAB8uXoa6m4pHhr0"
  });

  useEffect(() => {
    if (mapRef.current && props.data.length) {
      fitBoundsToMarkers();
    }
  }, [props.data]);

  const isValidLatLng = (lat, lng) => {
    return typeof lat === 'number' && !isNaN(lat) && typeof lng === 'number' && !isNaN(lng);
  };

  const fitBoundsToMarkers = () => {
    if (!mapRef.current) return;
    const bounds = new window.google.maps.LatLngBounds();
    props.data.forEach(location => {
      if (isValidLatLng(location?.coordinates?.lat, location?.coordinates?.lng)) {
        bounds.extend(new window.google.maps.LatLng(location.coordinates.lat, location.coordinates.lng));
      }
    });
    mapRef.current.fitBounds(bounds);
  };

  const getIconForAddressType = (addressType) => {
    if (!window.google) return null;
    const icons = {
      Pickup: 'https://maps.google.com/mapfiles/kml/paddle/red-circle.png',
      Drop: 'https://maps.google.com/mapfiles/kml/paddle/grn-circle.png',
      Truck: busyTruck,
    };
    return {
      url: icons[addressType] || 'https://maps.google.com/mapfiles/kml/paddle/grn-circle.png',
      scaledSize: new window.google.maps.Size(32, 32),
    };
  };

  const onMarkerClick = (location) => {
    setSelectedPlace(location);
    setActiveMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng });
  };

  const onMapClick = () => {
    setActiveMarker(null);
  };

  const onLoad = (map) => {
    mapRef.current = map;
    setMapLoaded(true);
    fitBoundsToMarkers();
  };

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading Maps...</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={props.zoom}
      onClick={onMapClick}
      onLoad={onLoad}
    >
      {mapLoaded && props.data.map((location, index) => {
        if (!isValidLatLng(location?.coordinates?.lat, location?.coordinates?.lng) || !location?.address) {
          return null;
        }

        const icon = getIconForAddressType(location.addressType);

        return (
          <Marker
            key={index}
            position={{ lat: location.coordinates.lat, lng: location.coordinates.lng }}
            icon={icon}
            onClick={() => onMarkerClick(location)}
          />
        );
      })}
      {activeMarker && (
        <InfoWindow
          position={activeMarker}
          onCloseClick={() => setActiveMarker(null)}
        >
          <div className="info-window">
            <h4 className="info-window-title">{selectedPlace.addressType}: {(selectedPlace.address||'').replace(/null/g, '').replace(/\s+/g, ' ').trim()}</h4>
            {selectedPlace.eta && <p className="info-window-eta">ETA: {selectedPlace.eta}</p>}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default RouteMap;
